/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Text 필드 클래스를 정의한다.
 *
 * @file /src/components/form/field/text/Text.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2025. 6. 13.
 */
import * as parent from '@components/form/field/input/Input';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {
    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Text extends parent.Input {
    /**
     * Input 확장타입
     */
    inputVariant = 'text';

    constructor(public properties: Properties<Text> = null) {
        super(properties);
    }
}
